<template>
  <div class="page">
    <Header>
      <template #title>
        リトル・ママチャンネル
      </template>
    </Header>
    <section class="inner">
      <ChannelProgram
        :program="onair"
        :onair="true"
        class="onair"
        v-if="onair"
      />
      <Title class="section-title">
        <template #title>
          7月28日(火)の配信スケジュール
        </template>
      </Title>
      <div class="schedules">
        <ChannelProgram
          v-for="(program, index) in day1" :key="index"
          :program="program"
        />
      </div>
    </section>
    <section class="inner">
      <Title class="section-title">
        <template #title>
          7月29日(水)の配信スケジュール
        </template>
      </Title>
      <div class="schedules">
        <ChannelProgram
          v-for="(program, index) in day2" :key="index"
          :program="program"
        />
      </div>
    </section>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import Header from '@/components/organisms/202007/Header.vue'
import Title from '@/components/atoms/Title.vue'
import ChannelProgram from '@/components/molecules/ChannelProgram.vue'

export default {
  name: 'channel',
  components: {
    Header,
    Title,
    ChannelProgram
  },
  computed: {
    ...mapState('channels202007', [
      'day1',
      'day2'
    ]),
    ...mapGetters('channels202007', [
      'onair'
    ])
  },
  mounted () {
    document.title = 'リトル・ママチャンネル - リトル・ママオンラインフェスタ'
  }
}
</script>

<style lang="sass" scoped>
.page
  padding: 60px 0
section
  padding: 30px 0 5px
  .section-title
    margin-bottom: 20px
    /deep/ h2
      font-size: 2rem
  .schedules
    > a:nth-child(n+2)
      margin-top: 25px
.onair
  margin-bottom: 30px
</style>
